import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight, Globe } from 'lucide-react';

export default function ValueBanner() {
  const [isVisible, setIsVisible] = useState(false);
  
  const STORAGE_KEY = 'geots_value_banner_closed';
  const HIDE_DURATION = 7 * 24 * 60 * 60 * 1000; // 7 days in ms

  useEffect(() => {
    // Check if banner was closed within the last 7 days
    const closedAt = localStorage.getItem(STORAGE_KEY);
    if (closedAt) {
      const closedTime = parseInt(closedAt, 10);
      if (Date.now() - closedTime < HIDE_DURATION) {
        setIsVisible(false);
        return;
      }
    }
    setIsVisible(true);
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="w-full bg-gradient-to-r from-[#0A2540] via-[#1a365d] to-[#635BFF] py-2.5 px-4 relative z-50">
      <div className="container mx-auto">
        <div className="flex items-center justify-center gap-3 md:gap-4">
          {/* Icon */}
          <div className="hidden sm:flex items-center justify-center w-8 h-8 rounded-full bg-white/10 flex-shrink-0">
            <Globe className="w-4 h-4 text-[#00D4FF]" />
          </div>
          
          {/* Message */}
          <p className="text-white text-sm md:text-base font-medium text-center">
            <span className="text-[#00D4FF] font-semibold">Nouveau</span>
            <span className="hidden sm:inline"> : la marketplace 100% spécialisée géotechnique & fondations spéciales</span>
            <span className="sm:hidden"> : 100% géotechnique & fondations</span>
          </p>
          
          {/* CTA Button - Now links to How It Works page */}
          <Link
            to="/comment-ca-marche"
            className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 text-white px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap border border-white/20"
          >
            <span className="hidden sm:inline">Découvrir</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
          
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="flex items-center justify-center w-7 h-7 rounded-full hover:bg-white/10 transition-colors flex-shrink-0 ml-2"
            aria-label="Fermer la bannière"
          >
            <X className="w-4 h-4 text-white/70 hover:text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}
